import Licensing from './licensing'

export default Licensing
